var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannedBeforeErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 101,
    viewBox: "0 0 146 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2357 12.5814L94.3459 9.77073L79.1336 1.00054L79.1235 1.00833L40.0078 23.5643L55.1997 32.328L60.0997 35.1454H60.1065L73.0162 42.5836L76.8854 44.8149L76.8921 44.8281L86.8313 39.0788L115.96 22.2681L115.987 22.2512L99.2357 12.5814Z",
    fill: "#FDDA97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5367 12.9758L93.6673 10.1587L79.1331 1.77589L41.3672 23.5632L55.969 31.8827L60.8894 34.6866L76.8917 43.8086L114.624 22.2502L98.5367 12.9758Z",
    fill: "#F7C475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8911 44.8276V47.1066L76.8843 54.2235L76.8471 94.9934L76.8403 95V94.9934L59.9902 85.3912L55.0969 82.6004L40 73.9981V23.5637L55.2021 32.3275L60.0987 35.1449L76.8843 44.8144L76.8911 44.8276Z",
    fill: "#B97139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.837 39.0715L76.8878 44.8144V47.1131L76.8845 54.2103L76.8438 94.9934V95L76.8505 94.9934L105.359 78.7172L116.003 72.6397V22.2676L86.837 39.0715Z",
    fill: "#DBA151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9897 35.2182V85.3906L55.0938 82.5999V32.4079L59.9897 35.2182Z",
    fill: "#956B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2284 12.575L85.5558 20.4845L80.6625 23.3083L60.1094 35.1458L59.9704 35.2305L55.0703 32.4093L55.206 32.3206L75.7726 20.4845L80.6625 17.6461L94.3554 9.77112L99.2284 12.575Z",
    fill: "#C7AA83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13 43.8944L94.2188 54.2109V38.8423L112.13 28.5112V43.8944Z",
    fill: "#E7E1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.432 33.1185L95.9219 41.4922V39.7647L110.432 31.4083V33.1185Z",
    fill: "#482819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.432 36.2124L95.9219 44.582V43.8307L110.432 35.4638V36.2124Z",
    fill: "#B0ABA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.432 38.2307L95.9219 46.5977V45.8358L110.432 37.4794V38.2307Z",
    fill: "#B0ABA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.432 40.4103L95.9219 48.7812V48.0154L110.432 39.6552V40.4103Z",
    fill: "#B0ABA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.432 42.4313L95.9219 50.7969V50.0391L110.432 41.6722V42.4313Z",
    fill: "#B0ABA6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2357 12.0814L54.3459 9.27073L39.1336 0.50054L39.1235 0.508331L0.0078125 23.0643L15.1997 31.828L20.0997 34.6454H20.1065L33.0162 42.0836L36.8854 44.3149L36.8921 44.3281L46.8313 38.5788L75.9603 21.7681L75.9874 21.7512L59.2357 12.0814Z",
    fill: "#FDDA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5367 12.4758L53.6673 9.65873L39.1331 1.27589L1.36719 23.0632L15.969 31.3827L20.8894 34.1866L36.8917 43.3086L74.6238 21.7502L58.5367 12.4758Z",
    fill: "#F7C475"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8911 44.3276V46.6066L36.8843 53.7235L36.8471 94.4934L36.8403 94.5V94.4934L19.9902 84.8912L15.0969 82.1004L0 73.4981V23.0637L15.2021 31.8275L20.0987 34.6449L36.8843 44.3144L36.8911 44.3276Z",
    fill: "#B97139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.837 38.5715L36.8878 44.3144V46.6131L36.8845 53.7103L36.8438 94.4934V94.5L36.8505 94.4934L65.3589 78.2172L76.0035 72.1397V21.7676L46.837 38.5715Z",
    fill: "#DBA151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9897 34.7182V84.8906L15.0938 82.0999V31.9079L19.9897 34.7182Z",
    fill: "#956B45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2284 12.075L45.5558 19.9845L40.6625 22.8083L20.1094 34.6458L19.9704 34.7305L15.0703 31.9093L15.206 31.8206L35.7726 19.9845L40.6625 17.1461L54.3554 9.27112L59.2284 12.075Z",
    fill: "#C7AA83"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1302 43.3944L54.2188 53.7109V38.3423L72.1302 28.0112V43.3944Z",
    fill: "#E7E1DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 32.6185L55.9219 40.9922V39.2647L70.4321 30.9083V32.6185Z",
    fill: "#482819"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 35.7124L55.9219 44.082V43.3307L70.4321 34.9638V35.7124Z",
    fill: "#B0ABA6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 37.7307L55.9219 46.0977V45.3358L70.4321 36.9794V37.7307Z",
    fill: "#B0ABA6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 39.9103L55.9219 48.2812V47.5154L70.4321 39.1552V39.9103Z",
    fill: "#B0ABA6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 41.9313L55.9219 50.2969V49.5391L70.4321 41.1722V41.9313Z",
    fill: "#B0ABA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 48.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.003 68.5012V72.5012M118.003 76.5012H118.013M116.293 63.3612L107.823 77.5012C107.648 77.8036 107.556 78.1465 107.555 78.4957C107.554 78.8449 107.644 79.1883 107.817 79.4917C107.99 79.7951 108.239 80.0479 108.54 80.225C108.841 80.4021 109.184 80.4973 109.533 80.5012H126.473C126.822 80.4973 127.164 80.4021 127.465 80.225C127.766 80.0479 128.015 79.7951 128.188 79.4917C128.361 79.1883 128.452 78.8449 128.451 78.4957C128.45 78.1465 128.357 77.8036 128.183 77.5012L119.713 63.3612C119.534 63.0673 119.283 62.8243 118.984 62.6557C118.684 62.487 118.346 62.3984 118.003 62.3984C117.659 62.3984 117.321 62.487 117.022 62.6557C116.722 62.8243 116.471 63.0673 116.293 63.3612Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 48.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannedBeforeErrorIcon);
export default __webpack_public_path__ + "9317d8ff5a3c9d0ca0419b2d75292737.svg";
export { ForwardRef as ReactComponent };